// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  appId: 'HotelWebsite',
  /*nzAPIUrl: 'https://testapi.bookonelocal.co.nz/api-bookone',
  inAPIUrl: 'https://testapi.bookonelocal.co.nz/api-bookone',
  apiUrlAddress: 'https://testapi.bookonelocal.co.nz/api-address',
  apiUrlPromotion: 'https://testapi.bookonelocal.co.nz/promotion-api',
  parentOrganisationId: 114,
  dashboardUrl: 'https://testapp.bookonelocal.co.nz',
  appUrl: 'https://thehotelmate.appspot.com',
  androidAppUrl: 'https://play.google.com/store/apps/details?id=nz.co.bookonelocal.customer',
  iosAppUrl: 'https://apps.apple.com/us/app/bookone-local/id1528910778',
  country: 'nz',*/

  nzAPIUrl: 'https://api.bookonelocal.co.nz/api-bookone',
  inAPIUrl: 'https://api.bookonelocal.in/api-bookone',
  apiUrlAddress: 'https://api.bookonelocal.in/api-address',
  apiUrlPromotion: 'https://api.bookonelocal.in/promotion-api',
  parentOrganisationId: 1,
  dashboardUrl: 'https://app.bookonelocal.in',
  appUrl: 'https://thehotelmate.com',
  androidAppUrl: 'https://play.google.com/store/apps/details?id=nz.co.bookonelocal.customer',
  iosAppUrl: 'https://apps.apple.com/us/app/bookone-local/id1528910778',
  country: 'in',
  googleKey: 'AIzaSyBYGJ1SMIW5BIny9Af7eoozmgSGZShhUuE',
  callbackUrl: 'http://lcoalhost:4200/#/details?ReferenceNumber='
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
